export default "__VITE_ASSET__rtbybifW__"